import ICOABI from "../ABI/ICOABI.json"
import VOUCHERABI from "../ABI/VOUCHERABI.json"
import tokenABI from "../ABI/BEP20ABI.json"
import USDTABI from "../ABI/USDTABI.json"
import Web3 from "web3";
import { convert } from "../helper/convert";
import { Multicall } from "ethereum-multicall";
import config from "../config/config";
import { getFormatMulticall, formatNumber } from "../helper/custommath";
import moment from "moment"

export async function getBalanceInfo(address, transport) {


    try {
        if (!address) {
            address = "0x0000000000000000000000000000000000000000"
        }
        var web3 = new Web3(config.rpc);
        // const multicall = new Multicall({
        //     web3Instance: web3,
        // });

        // var Contract = [
        //     {
        //         reference: "balanceOf",
        //         contractAddress: "0x9336E83E6Bb110899b40bC10B74E2E9fECF7922D",
        //         abi: tokenABI,
        //         calls: [
        //             {
        //                 reference: "balanceOf",
        //                 methodName: "balanceOf",
        //                 methodParameters: [address],
        //             },
        //             {
        //                 reference: "allowance",
        //                 methodName: "allowance",
        //                 methodParameters: [address, config.contractAddress],
        //             },
        //         ]
        //     },
        //     {
        //         reference: "tokenprice",
        //         contractAddress: "0xbeD6F428c3182E2b19CAC5B74Efc475E8e5A7988",
        //         abi: ICOABI,
        //         calls: [
        //             {
        //                 reference: "getTokenprice",
        //                 methodName: "getTokenprice",
        //                 methodParameters: [],
        //             }
        //         ]
        //     },
        // ];

        let tknContract = new web3.eth.Contract(tokenABI, config.usdtContract);
        var balanceOf = await tknContract.methods.balanceOf(address).call();
        balanceOf = parseInt(balanceOf) / 10 ** 18;
        var allowance = await tknContract.methods.allowance(address, config.contractAddress).call();
        allowance = parseInt(allowance) / 10 ** 18;
        console.log(balanceOf, 'balanceOfbalanceOfbalanceOf')
        let icoContract = new web3.eth.Contract(ICOABI, config.contractAddress);
        var tokenprice = await icoContract.methods.getTokenprice().call();
        tokenprice = parseInt(tokenprice);

        var users = await icoContract.methods.users(address).call();

        var totalusers = await icoContract.methods.totalUsers().call();
        totalusers = parseInt(totalusers)
        var totalinvestmanet = await icoContract.methods.totalinvestmanet().call();
        totalinvestmanet = formatNumber(parseFloat(totalinvestmanet) / 10 ** 18, 4)
        var totalreward = await icoContract.methods.totalreward().call();
        totalreward = formatNumber(parseFloat(totalreward) / 10 ** 18, 4)
        var userWin = parseInt(users?.reward) || 0;
        var claimableamount = parseInt(users?.claimableamount) || 0;
        let availableReward = formatNumber(parseFloat(userWin) / 10 ** 18, 4)

        var bonus = await icoContract.methods.bonus().call();
        bonus = parseFloat(bonus);

        //var bonus = 

        // const results = await multicall.call(Contract);
        // var balanceOf = await getFormatMulticall(results, "balanceOf", 0);
        // balanceOf = parseInt(balanceOf.hex) / 10 ** 18;
        // var allowance = await getFormatMulticall(results, "balanceOf", 1);
        // allowance = parseInt(allowance.hex) / 10 ** 18;

        // var tokenprice = await getFormatMulticall(results, "tokenprice", 0);
        console.log(totalusers, "totalusers");
        return {
            balanceOf,
            allowance,
            tokenprice,
            totalusers,
            totalinvestmanet,
            totalreward,
            availableReward,
            rewardPerc: bonus,
            claimable: claimableamount
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerr211212')
        return {
            balanceOf: 0,
            allowance: 0,
            tokenprice: 0,
            totalUsers: 0,
            totalinvestmanet: 0,
            totalreward: 0,
            availableReward: 0
        };
    }

}


export async function approveToken(address, transport) {

    var tkn = 1000 * 10 ** 18;
    tkn = convert(tkn.toString());

    console.log(config.contractAddress,
        '121212121212121212', address, transport, tkn)
    try {
        var web3 = new Web3(transport);
        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        let Contractsss = new web3.eth.Contract(USDTABI, config.usdtCont);
        console.log(config.vouchorAddress,
            '121212121212121212AAAAAAA', address, tkn, balance)
        var estimateGas = await Contractsss.methods.approve(
            config.vouchorAddress,
            tkn
        ).estimateGas({ from: address });
        estimateGas = parseInt(estimateGas) + 30000;

        if (parseFloat(estimateGas) / 10 ** 8 > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }

        var result = await Contractsss.methods.approve(
            config.vouchorAddress,
            tkn
        ).send({ from: address });

        var approvalAmt = (result && result.events && result.events.Approval && result.events.Approval.returnValues
            && result.events.Approval.returnValues && result.events.Approval.returnValues
            && result.events.Approval.returnValues.value) ?
            parseFloat(result.events.Approval.returnValues.value) : 0
        approvalAmt = approvalAmt / 10 ** 18;

        return {
            approvalAmt: approvalAmt,
            isAllowed: (result && result.status) ? result.status : false,
            error: ""
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerrerr121212')

        var error = err.toString();
        console.log(error, 'error')
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }

        return {
            approvalAmt: 0,
            isAllowed: false,
            error: message
        }

    }

}


export async function buyToken(transport, address, refaddress, amount, phasesId) {
    try {
        console.log(transport, address, refaddress, amount, phasesId, "aaaaaaaaaaaaaaaaaaa");
        var web3 = new Web3(transport);
        var currnetwork = await web3.eth.net.getId();

        if (currnetwork != config.chainId) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please login into bsc chain.`
            }
        }

        var tkn = amount * 10 ** 18;
        tkn = convert(tkn);

        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        let Contractsss = new web3.eth.Contract(VOUCHERABI, config.vouchorAddress);
        var estimateGas = await Contractsss.methods.buy(
            phasesId, tkn, refaddress
        ).estimateGas({ from: address });
        estimateGas = parseInt(estimateGas) + 30000;

        if (parseFloat(estimateGas) / 10 ** 8 > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }

        var result = await Contractsss.methods.buy(
            phasesId, tkn, refaddress
        ).send({ from: address, gasPrice: gasPrice, gasLimit: estimateGas });

        console.log(result, 'resultresultresult121212')

        let transactionHash = result?.transactionHash;
        let tokenAmount = result?.events?.Purchased?.returnValues?.tokenAmount || 0;
        let usdtAmount = result?.events?.Purchased?.returnValues?.usdtAmount || 0;
        let buyer = result?.events?.Purchased?.returnValues?.buyer || 0;
        let referrer = result?.events?.Purchased?.returnValues?.referrer || 0;
        let amountPaidAmount = result?.events?.ReferralPaid?.returnValues?.amount || 0;

        console.log(parseInt(tokenAmount) / 10 ** 18,
            parseInt(usdtAmount) / 10 ** 18,
            buyer,
            referrer,
            parseInt(amountPaidAmount) / 10 ** 18, "ssssssss");

        return {
            status: (result && result.status) ? result.status : false,
            txId: transactionHash,
            tokenAmount: tokenAmount ? parseInt(tokenAmount) / 10 ** 18 : 0,
            usdtAmount: usdtAmount ? parseInt(usdtAmount) / 10 ** 18 : 0,
            refBonusAmt: parseInt(amountPaidAmount) / 10 ** 18,
            buyer,
            referrer,
            message: ""
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerr233423232323', err?.error?.message)
        var error = err.toString();
        console.log(error, 'error')
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }
        return {
            status: false,
            message: message,
            txId: "",
            reward: 0
        }

    }

}

export async function getInfo() {
    try {
        var web3 = new Web3(config.rpc);
        let icoContract = new web3.eth.Contract(ICOABI, config.contractAddress);
        var totalreward = await icoContract.methods.totalreward().call();
        totalreward = formatNumber(parseFloat(totalreward) / 10 ** 18, 4)
        return totalreward;
    } catch (err) {
        return 0;
    }

}


export async function claimToken(address, transport) {
    try {
        var web3 = new Web3(transport);
        var currnetwork = await web3.eth.net.getId();

        if (currnetwork != config.chainId) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please login into bsc chain.`
            }
        }


        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        let Contractsss = new web3.eth.Contract(ICOABI, config.contractAddress);
        var estimateGas = await Contractsss.methods.claimReward().estimateGas({ from: address });
        estimateGas = parseInt(estimateGas) + 30000;

        if (parseFloat(estimateGas) / 10 ** 8 > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }

        var result = await Contractsss.methods.claimReward().send({ from: address, gasPrice: gasPrice, gasLimit: estimateGas });


        let transactionHash = result?.transactionHash;
        let reward = result?.events?.Claim?.returnValues?.rewardAmount || 0;
        return {
            status: (result && result.status) ? result.status : false,
            error: "",
            txId: transactionHash,
            reward: reward ? parseInt(reward) / 10 ** 18 : 0,
            message: ""
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerr233423232323', err?.error?.message)
        var error = err.toString();
        console.log(error, 'error')
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }
        return {
            status: false,
            message: message,
            txId: "",
            reward: 0
        }

    }

}


export async function getPhasesList() {
    try {
        var web3 = new Web3(config.rpc);
        let vouchContract = new web3.eth.Contract(VOUCHERABI, config.vouchorAddress);

        const totalPhases = await vouchContract.methods.phasesCount().call();
        const phases = [];

        for (let i = 1; i <= parseInt(totalPhases); i++) {
            const phaseData = await vouchContract.methods.phases(i).call();

            phases.push({
                id: i,
                name: phaseData.name,
                allocation: Number((parseFloat(phaseData.allocation) / 10 ** 18).toFixed(0)),
                pricePerWin: Number((parseFloat(phaseData.pricePerWin) / 10 ** 18).toFixed(1)),
                sold: Number((parseFloat(phaseData.sold) / 10 ** 18).toFixed(0)),
                active: phaseData.active,
                completed: phaseData.completed,
            });

        }
        return phases;
    } catch (err) {
        console.error("Error fetching phase list:", err);
        return [];
    }
}


export async function getVouchorBalance(address) {
    try {
        if (!address) {
            address = "0x0000000000000000000000000000000000000000";
        }
        console.log(config.usdtCont, address, config.vouchorAddress, "config.usdtCont");
        var web3 = new Web3(config.rpc);
        let tknContract = new web3.eth.Contract(USDTABI, config.usdtCont);

        let balanceOf = await tknContract.methods.balanceOf(address).call();
        balanceOf = parseInt(balanceOf) / 10 ** 18;
        console.log(balanceOf, "balanceOfbalanceOf");

        let allowance = await tknContract.methods.allowance(address, config.vouchorAddress).call();
        allowance = parseInt(allowance) / 10 ** 18;

        console.log(balanceOf, allowance, "allowanceallowance");

        return { balanceOf, allowance };
    } catch (err) {
        console.log(err, 'errerrerrerrerr211212');
        return { balanceOf: 0, allowance: 0 };
    }
}

export async function getInvestDetails(address) {
    try {
        if (!address) {
            address = "0x0000000000000000000000000000000000000000";
        }
        var web3 = new Web3(config.rpc);
        let voucherContract = new web3.eth.Contract(VOUCHERABI, config.vouchorAddress);
        let userInfo = await voucherContract.methods.getUserInfo(address).call();
        let userClaimed = await voucherContract.methods.userClaimedTotal(address).call();

        console.log(userInfo, userClaimed, "userInfouserInfo");
        return {
            myInvest: userInfo?.totalInvestedUSDT ? parseInt(userInfo?.totalInvestedUSDT) / 10 ** 18 : 0,
            myReward: userInfo?.assignedTokens ? parseInt(userInfo?.assignedTokens) / 10 ** 18 : 0,
            totalBid: userInfo?.totalStakedTokens ? parseInt(userInfo?.totalStakedTokens) / 10 ** 18 : 0,
            totalClaimed: userClaimed ? parseInt(userClaimed) / 10 ** 18 : 0
        };

    } catch (err) {
        console.log(err, 'errerrerrerrerr211212');
        return {
            myInvest: 0,
            myReward: 0,
            totalBid: 0
        };
    }
}


export async function claimBidProcess(address, transport, withdrawPer, bucketIds,
    bucketAmounts) {
    console.log(address,
        bucketIds, bucketAmounts,
        withdrawPer, "withdrawwww");
    try {
        var web3 = new Web3(transport);
        var currnetwork = await web3.eth.net.getId();


        if (currnetwork != config.chainId) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please login into bsc chain.`
            }
        }


        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        let Contractsss = new web3.eth.Contract(VOUCHERABI, config.vouchorAddress);
        var estimateGas = await Contractsss.methods.claimOrStakeNew(withdrawPer, bucketIds, bucketAmounts).estimateGas({ from: address });
        estimateGas = parseInt(estimateGas) + 30000;

        if (parseFloat(estimateGas) / 10 ** 8 > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }

        var result = await Contractsss.methods.claimOrStakeNew(withdrawPer, bucketIds, bucketAmounts).send({ from: address, gasPrice: gasPrice, gasLimit: estimateGas });

        console.log(result, "claimmmmmmm");
        let transactionHash = result?.transactionHash;
        let bidAmount = result?.events?.ClaimedAndStaked?.returnValues?.stakedAmount || 0;
        let withAmt = result?.events?.withdrawnAmount?.returnValues?.withdrawnAmount || 0;
        return {
            status: (result && result.status) ? result.status : false,
            error: "",
            txId: transactionHash,
            message: ""
        }

    } catch (err) {
        console.log(err, 'errerrerrerrerr233423232323', err?.error?.message)
        var error = err.toString();
        console.log(error, 'error')
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }
        return {
            status: false,
            message: message,
            txId: "",
            bidAmount: 0,
            withAmt: 0
        }

    }

}

export async function getUserVoucherDetails(address) {
    try {
        const web3 = new Web3(config.rpc);
        const vouchContract = new web3.eth.Contract(VOUCHERABI, config.vouchorAddress);

        const voucherIds = await vouchContract.methods.getUserVouchers(address).call();

        const voucherDetails = [];

        for (let id of voucherIds) {
            const data = await vouchContract.methods.getVoucher(id).call();
            const voucherRedeemdata = await vouchContract.methods.voucherRedeemEnabled(id).call();
            const voucherRedeemEnabled = voucherRedeemdata;
            console.log(voucherRedeemdata, "voucherRedeemdata");
            console.log(data, "datadata");
            const createdDate =
                data?.createdAt && Number(data?.createdAt) > 0
                    ? moment.unix(Number(data.createdAt)).format("DD-MM-YYYY hh:mm A")
                    : null;

            if (data.tokenAmount > 0) {
                voucherDetails.push({
                    id: Number(data.id),
                    bucketId: Number(data.bucketId),
                    buyer: data?.buyer,
                    claimedAmount: Number(data?.claimedAmount),
                    serial: Number(data?.serial),
                    tokenAmount: Number(web3.utils.fromWei(data?.tokenAmount, "ether")),
                    phaseId: Number(data?.phaseId),
                    createdAt: createdDate,
                    voucherRedeemEnabled,
                });
            }

        }

        return voucherDetails;
    } catch (err) {
        console.error("Error fetching user vouchers:", err);
        return [];
    }
}

export async function redeemVoucher(address, transport, voucherId) {
    console.log('address :', address);
    console.log('transport :', transport);
    console.log('voucherId :', voucherId);
    try {
        var web3 = new Web3(transport);
        var currnetwork = await web3.eth.net.getId();

        if (currnetwork != config.chainId) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please login into bsc chain.`
            }
        }

        var gasPrice = await web3.eth.getGasPrice();
        var balance = await web3.eth.getBalance(address);
        console.log('balance :', balance);
        let Contractsss = new web3.eth.Contract(VOUCHERABI, config.vouchorAddress);
        var estimateGas = await Contractsss.methods.redeem(voucherId).estimateGas({ from: address });
        estimateGas = parseInt(estimateGas) + 30000;
        console.log('estimateGas :', estimateGas);

        if (parseFloat(estimateGas) / 10 ** 8 > balance) {
            return {
                isAllowed: false,
                approvalAmt: 0,
                error: `Please make sure you have gas fee(${parseFloat(estimateGas) / 10 ** 8} BNB) in your wallet.`
            }
        }
        var result = await Contractsss.methods.redeem(voucherId).send({ from: address, gasPrice: gasPrice, gasLimit: estimateGas });
        console.log(result, "redeeeemmmmmm");

        let transactionHash = result?.transactionHash;
        return {
            status: (result && result.status) ? result.status : false,
            error: "",
            txId: transactionHash,
            message: ""
        }

    } catch (err) {
        console.log(err, 'errrerererererere324324234234', err?.error?.message)
        var error = err.toString();
        console.log(error, 'error')
        var pos = error.search("User denied")
        var pos1 = error.search("funds")
        var message = "Please try again later";
        if (pos >= 0) {
            message = "Cancelled the transaction";
        } else if (pos1 >= 0) {
            message = "Insufficient funds";
        }
        return {
            status: false,
            message: message,
            txId: "",
        }
    }
}